import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Sidebar = ({ currentPage, user, onLogout }) => {
  const navigate = useNavigate();
  const [recrutamentoOpen, setRecrutamentoOpen] = useState(false);

  // Taliane não vê o Onboarding
  const isTaliane = user.email === 'talianesaldanha@remax.com.br';
  
  const menuItems = isTaliane ? [
    { id: 'documentos', label: 'Documentos', icon: '📁', path: '/documentos' }
  ] : [
    { id: 'dashboard', label: 'Onboarding', icon: '📊', path: '/' },
    { id: 'documentos', label: 'Documentos', icon: '📁', path: '/documentos' }
  ];

  return (
    <div style={{ 
      width: '240px', 
      background: 'linear-gradient(180deg, #1e293b 0%, #0f172a 100%)', 
      color: 'white', 
      padding: '0',
      flexShrink: 0,
      boxShadow: '2px 0 10px rgba(0,0,0,0.1)',
      minHeight: '100vh'
    }}>
      <div style={{ padding: '20px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
        <div style={{ 
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '10px'
        }}>
          <img 
            src="/logo-remax.png" 
            alt="RE/MAX Logo" 
            style={{ 
              width: '120px',
              height: '120px',
              borderRadius: '50%',
              objectFit: 'cover',
              boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
              border: '3px solid rgba(255,255,255,0.2)'
            }} 
          />
        </div>
      </div>

      <nav style={{ padding: '20px' }}>
        {menuItems.map((item) => {
          const isActive = currentPage === item.id;
          
          return (
            <div
              key={item.id}
              onClick={() => navigate(item.path)}
              style={{
                padding: '14px 16px',
                marginBottom: '8px',
                borderRadius: '8px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                fontSize: '14px',
                transition: 'all 0.2s',
                background: isActive 
                  ? 'linear-gradient(135deg, rgba(220, 38, 38, 0.2) 0%, rgba(185, 28, 28, 0.2) 100%)'
                  : 'transparent',
                borderLeft: isActive ? '3px solid #dc2626' : '3px solid transparent',
                fontWeight: isActive ? '600' : '400'
              }}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)';
                  e.currentTarget.style.transform = 'translateX(4px)';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.transform = 'translateX(0)';
                }
              }}
            >
              <span style={{ fontSize: '18px' }}>{item.icon}</span>
              <span>{item.label}</span>
            </div>
          );
        })}

        {/* Recrutamento Dropdown */}
        <div style={{ marginBottom: '8px' }}>
          <div
            onClick={() => setRecrutamentoOpen(!recrutamentoOpen)}
            style={{
              padding: '14px 16px',
              borderRadius: '8px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              fontSize: '14px',
              transition: 'all 0.2s',
              background: currentPage === 'recrutamento' 
                ? 'linear-gradient(135deg, rgba(220, 38, 38, 0.2) 0%, rgba(185, 28, 28, 0.2) 100%)'
                : 'transparent',
              borderLeft: currentPage === 'recrutamento' ? '3px solid #dc2626' : '3px solid transparent',
              fontWeight: currentPage === 'recrutamento' ? '600' : '400'
            }}
            onMouseEnter={(e) => {
              if (currentPage !== 'recrutamento') {
                e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)';
              }
            }}
            onMouseLeave={(e) => {
              if (currentPage !== 'recrutamento') {
                e.currentTarget.style.backgroundColor = 'transparent';
              }
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span style={{ fontSize: '18px' }}>💼</span>
              <span>Recrutamento</span>
            </div>
            <span style={{ transform: recrutamentoOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
              ▼
            </span>
          </div>
          
          {recrutamentoOpen && (
            <div style={{ paddingLeft: '46px', marginTop: '4px' }}>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  navigate('/recrutamento-dashboard');
                }}
                style={{
                  padding: '10px 12px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '13px',
                  transition: 'background 0.2s',
                  marginBottom: '4px'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              >
                📊 Dashboard
              </div>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  navigate('/recrutamento-silver');
                }}
                style={{
                  padding: '10px 12px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '13px',
                  transition: 'background 0.2s',
                  marginBottom: '4px'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              >
                📋 Visualizar Oportunidades
              </div>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  if (window.openNovaOportunidade) {
                    window.openNovaOportunidade();
                  }
                }}
                style={{
                  padding: '10px 12px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '13px',
                  transition: 'background 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              >
                ➕ Nova Oportunidade
              </div>
            </div>
          )}
        </div>

        <div
          onClick={onLogout}
          style={{
            padding: '14px 16px',
            marginTop: '30px',
            borderRadius: '8px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            fontSize: '14px',
            border: '1px solid rgba(255,255,255,0.2)',
            transition: 'all 0.2s',
            backgroundColor: 'transparent'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(220, 38, 38, 0.2)';
            e.currentTarget.style.borderColor = '#dc2626';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)';
          }}
        >
          <span style={{ fontSize: '18px' }}>🚪</span>
          <span>Sair</span>
        </div>

        {/* User Info */}
        <div style={{ 
          marginTop: '40px', 
          padding: '16px', 
          borderRadius: '8px', 
          backgroundColor: 'rgba(255,255,255,0.05)',
          borderTop: '1px solid rgba(255,255,255,0.1)'
        }}>
          <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.6)', marginBottom: '4px' }}>
            {user.role === 'administrador' ? 'Administrador' : 'Gestor'}
          </div>
          <div style={{ fontSize: '13px', fontWeight: '600', color: 'white' }}>
            {user.nome}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
